import { IconSet } from '../IconSet';

/**
 * Our icons require the FFX prefix to avoid collisions with the Fluent UI Icons.
 *
 * The values here must match the unicode value of the character in the font.
 * You can get this value from https://iconcloud.design
 */
export const icons = {
  FFXAccounts: '\uE910',
  FFXClock: '\uE917',
  FFXFeedback: '\uED15',
  FFXFolderHorizontal: '\uF12B',
  FFXOpenInNewTab: '\uF6AB',
  FFXPageAdd: '\uEA1A',
  FFXSettings: '\uE713',
  FFXShare: '\uE72D',
  FFXWarningSolid: '\uF736',

  // Icons from Fabric UI that we need to handle
  chevrondown: '\uE70D',
  contact: '\uE77B',
  cancel: '\uE711',
  clear: '\uE711'
};

export const fluidPreviewAppIcons: IconSet = {
  fontFamily: 'fluid-preview-app',
  fontExtension: 'woff',

  // Must be manually updated whenever there is a change of the font file.
  sha: '4d57a60d62',
  icons
};

/**
 * Type containing the icon names of this icon set.
 */
export type FluidPreviewAppIconsType = keyof typeof icons;
